import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Testimonials } from './components/Testimonials';
import { PainSection } from './components/PainSection';
import { TomosGrid } from './components/TomosGrid';
import { BonosSection } from './components/BonosSection';
import { Pricing } from './components/Pricing';
import { CerebroComparison } from './components/CerebroComparison';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostTable } from './components/CostTable';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
const testimonialsBlock1 = [{
  initials: 'MG',
  quote: 'Organicé todo el trimestre en una tarde. Los prompts de informes me ahorran horas cada semana.',
  author: 'María G.',
  role: 'Córdoba · Maestra de 4° Grado'
}, {
  initials: 'LP',
  quote: 'Las rúbricas del Tomo 5 son lo que siempre busqué y nunca encontré hechas. Vale cada peso.',
  author: 'Laura P.',
  role: 'Rosario · Docente de Secundaria'
}, {
  initials: 'RM',
  quote: 'Mis clases dejaron de ser improvisadas. Tengo todo el año resuelto. Es un antes y un después.',
  author: 'Roberto M.',
  role: 'Buenos Aires · Maestro de 6° Grado'
}];
const testimonialsBlock2 = [{
  initials: 'CR',
  quote: 'Mis colegas me preguntan cómo tengo todo tan rápido. El guión del acto lo tengo en 10 minutos.',
  author: 'Cecilia R.',
  role: 'Mendoza · Maestra de 3° Grado'
}, {
  initials: 'SC',
  quote: '30 informes en una tarde. Antes me llevaba una semana. El Tomo 3 cambió mi trimestre completo.',
  author: 'Sofía C.',
  role: 'La Plata · Maestra de 5° Grado'
}, {
  initials: 'PA',
  quote: 'El Cerebro Digital me organizó 8 años de archivos en un fin de semana. Encuentro todo en segundos.',
  author: 'Pablo A.',
  role: 'Neuquén · Profesor de Secundaria'
}, {
  initials: 'VL',
  quote: 'Las rúbricas las entrego antes de la actividad. Mis alumnos saben exactamente qué se espera.',
  author: 'Valentina L.',
  role: 'Rosario · Maestra de 6° Grado'
}];
export function App() {
  return <div className="min-h-screen bg-noche font-sans selection:bg-tealBrand selection:text-noche" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <UrgencyBar data-id="element-2" />
      <main data-id="element-3">
        <Hero data-id="element-4" />
        <StatsBar data-id="element-5" />
        <Testimonials testimonials={testimonialsBlock1} data-id="element-6" />
        <PainSection data-id="element-7" />
        <TomosGrid data-id="element-8" />
        <BonosSection data-id="element-9" />
        <Pricing data-id="element-10" />
        <CerebroComparison data-id="element-11" />

        {/* Testimonials Block 2 - Using a slightly different layout for variety */}
        <section className="py-10 px-6 bg-nocheLight" data-id="element-12">
          <div className="max-w-7xl mx-auto" data-id="element-13">
            <h3 className="text-2xl font-bold text-center text-white mb-6 flex items-center justify-center gap-2" data-id="element-14">
              <span className="text-red-500" data-id="element-15">❤️</span> MÁS DOCENTES QUE YA LO
              TIENEN
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-16">
              {testimonialsBlock2.map((t, idx) => <div key={idx} className="bg-petroleo rounded-2xl p-6 border border-tealBrand/10 flex flex-col h-full" data-id="element-17">
                  <div className="flex items-center gap-3 mb-4" data-id="element-18">
                    <div className="w-10 h-10 rounded-full bg-tealBrand/20 text-tealBrand flex items-center justify-center font-bold text-sm" data-id="element-19">
                      {t.initials}
                    </div>
                    <div className="flex text-amarillo text-sm" data-id="element-20">⭐⭐⭐⭐⭐</div>
                  </div>
                  <p className="text-gray-300 text-sm italic mb-4 flex-grow" data-id="element-21">
                    "{t.quote}"
                  </p>
                  <div data-id="element-22">
                    <div className="font-bold text-white text-sm" data-id="element-23">
                      {t.author}
                    </div>
                    <div className="text-xs text-tealBrand mt-0.5" data-id="element-24">
                      {t.role}
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
        </section>

        <Guarantee data-id="element-25" />
        <FAQ data-id="element-26" />
        <CostTable data-id="element-27" />
        <FinalCTA data-id="element-28" />
      </main>
      <Footer data-id="element-29" />
    </div>;
}